<template>
  <DefaultSection class="cta has-background-primary">
    <Container>
      <div class="columns">
        <div
          class="column is-8 has-text-centered-mobile title is-size-large has-text-white"
        >
          <span class="has-text-weight-medium"> {{ title }}&nbsp;</span>
          <Typed :options="options">
            <span class="typing has-text-weight-bold" />
          </Typed>
        </div>
        <div
          class="column is-3 is-offset-1-widescreen has-text-centered-mobile"
        >
          <VuepalLink
            v-if="link && link.url"
            :to="link.url.path"
            class="button has-text-weight-bold is-large is-size-normal mt-3 has-text-right has-text-centered-mobile"
            :class="buttonClass"
          >
            {{ link.title }}
          </VuepalLink>
        </div>
      </div>
    </Container>
  </DefaultSection>
</template>

<script setup lang="ts">
import { Typed } from '@duskmoon/vue3-typed-js'
import type { TypedOptions } from '@duskmoon/vue3-typed-js'
import type { ParagraphCallToActionFragment } from '#graphql-operations'

const props = defineProps<ParagraphCallToActionFragment>()

const options: TypedOptions = {
  strings: [props.animation ?? ''],
  loop: true,
  typeSpeed: 100,
  showCursor: true,
  cursorChar: '_',
  backSpeed: 50,
  backDelay: 6000,
}

defineBlokkli({
  bundle: 'call_to_action',
})

const buttonClass = useButtonClass()
</script>

<style scoped lang="scss">
.cta {
  padding-top: toRem(40);
  padding-bottom: toRem(40);

  @include tablet {
    padding-top: toRem(100);
    padding-bottom: toRem(100);
  }

  .typed-element {
    display: inline;

    .typed-cursor {
      font-size: toRem(40);
      color: $white;
    }
  }
}
</style>
